import {
  IDocumentMediaPreviewData,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { Swiper, SwiperSlide } from "swiper/react";
import React, { Dispatch, SetStateAction } from "react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import DisplayThumbImage from "./mediaThumb/DisplayThumbImage";
import VideoThumb from "./mediaThumb/VideoThumb";
import AudioThumb from "./mediaThumb/AudioThumb";
import { MediaThumb } from "./MediaThumb";

const MediaThumbPreview = ({
  mediaList,
  setThumbsSwiper,
  initialSlideIndex = 0,
}: {
  mediaList: IDocumentMediaPreviewData[];
  setThumbsSwiper: Dispatch<SetStateAction<any>>;
  initialSlideIndex?: number;
}) => {
  const swiperThumbProp = {
    onSwiper: setThumbsSwiper,
    slidesPerView: 13,
    spaceBetween: 5,
    navigation: true,
    centeredSlides: true,
    keyboard: true,
    slideToClickedSlide: true,
    autoplay: false,
    loop: false,
    modules: [FreeMode, Navigation, Thumbs],
    className: "thumb-swiper",
    initialSlide: initialSlideIndex,
  };

  return (
    <Swiper {...swiperThumbProp}>
      {mediaList.map(mediaMessage => {
        const hasMedia =
          Array.isArray(mediaMessage.media) && mediaMessage.media.length > 0;
        return (
          <React.Fragment key={mediaMessage.id}>
            {mediaMessage.mediaType === MESSAGE_CONTENT_TYPE.IMAGE &&
              (hasMedia ? (
                <>
                  {mediaMessage.media.map((image, i) => {
                    const imageUrl: string = (image?.url ?? image) as string;
                    return (
                      <SwiperSlide key={mediaMessage.id + i + "image-slide"}>
                        <MediaThumb>
                          <DisplayThumbImage
                            imageData={{
                              url: imageUrl,
                              text: mediaMessage.title ?? "",
                            }}
                            style={{ borderRadius: "3px" }}
                          />
                        </MediaThumb>
                      </SwiperSlide>
                    );
                  })}
                </>
              ) : (
                <SwiperSlide key={mediaMessage.id + "image-slide"}>
                  <MediaThumb>
                    <DisplayThumbImage
                      imageData={{
                        url: mediaMessage.media?.[0]?.url ?? "",
                        text: mediaMessage.title ?? "",
                      }}
                    />
                  </MediaThumb>
                </SwiperSlide>
              ))}

            {mediaMessage.mediaType === MESSAGE_CONTENT_TYPE.VOICE &&
              hasMedia && (
                <SwiperSlide key={mediaMessage.id + "audio-slide"}>
                  <AudioThumb
                    voiceMessage={{
                      url: mediaMessage.media?.[0]?.url ?? "",
                      duration: String(mediaMessage.media?.[0]?.duration ?? ""),
                      mediaType: mediaMessage.media?.[0]?.mediaType ?? "VOICE",
                    }}
                  />
                </SwiperSlide>
              )}

            {mediaMessage.mediaType === MESSAGE_CONTENT_TYPE.VIDEO &&
              (hasMedia ? (
                <>
                  {mediaMessage.media.map((video, i) => (
                    <SwiperSlide key={mediaMessage.id + i + "video-slide"}>
                      <MediaThumb>
                        <VideoThumb
                          videoData={{
                            thumbnail: video?.thumbnail ?? "",
                            text: mediaMessage.title ?? "",
                            url: video?.url ?? "",
                          }}
                        />
                      </MediaThumb>
                    </SwiperSlide>
                  ))}
                </>
              ) : (
                <SwiperSlide key={mediaMessage.id + "video-slide"}>
                  <MediaThumb>
                    <VideoThumb
                      videoData={{
                        thumbnail: mediaMessage.media?.[0]?.thumbnail ?? "",
                        text: mediaMessage.title ?? "",
                        url: mediaMessage.media?.[0]?.url ?? "",
                      }}
                    />
                  </MediaThumb>
                </SwiperSlide>
              ))}
          </React.Fragment>
        );
      })}
    </Swiper>
  );
};

export default MediaThumbPreview;
